import { getAceLoaderNames } from "./ace-loader.get-names";
import { h } from "@stencil/core";
import { Config } from "../../utils/config/config";
export class AceLoader {
    constructor() {
        this.show = false;
        this.size = 'medium';
        this.forceMode = null;
    }
    componentWillLoad() {
        var _a;
        this.names = getAceLoaderNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
    }
    render() {
        let classList = {
            [this.names.CLASS.ROOT]: true,
            [this.names.CLASS.____ANIMATION_DISABLED]: Config.isTimersAndAnimationsDisabled(),
            [this.names.CLASS.____SIZE_XX_SMALL]: this.size === 'xx-small',
            [this.names.CLASS.____SIZE_X_SMALL]: this.size === 'x-small',
            [this.names.CLASS.____SIZE_MEDIUM]: this.size === 'medium',
            [this.names.CLASS.____FORCE_MODE_LIGHT]: this.forceMode === 'light',
            [this.names.CLASS.____FORCE_MODE_DARK]: this.forceMode === 'dark',
        };
        return this.show && h("span", { key: 'a6224abe2ba6d2b69c21e5e36264290f31986cee', id: this.names.ID.ROOT, class: classList });
    }
    static get is() { return "ace-loader"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-loader.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-loader.css"]
        };
    }
    static get properties() {
        return {
            "show": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether the loader is visible or not."
                },
                "attribute": "show",
                "reflect": false,
                "defaultValue": "false"
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceLoaderSize",
                    "resolved": "\"medium\" | \"x-small\" | \"xx-small\"",
                    "references": {
                        "IAceLoaderSize": {
                            "location": "import",
                            "path": "./ace-loader.types",
                            "id": "src/components/ace-loader/ace-loader.types.ts::IAceLoaderSize"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "'medium'"
            },
            "forceMode": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceLoaderMode",
                    "resolved": "\"dark\" | \"light\"",
                    "references": {
                        "IAceLoaderMode": {
                            "location": "import",
                            "path": "./ace-loader.types",
                            "id": "src/components/ace-loader/ace-loader.types.ts::IAceLoaderMode"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "force-mode",
                "reflect": false,
                "defaultValue": "null"
            }
        };
    }
    static get elementRef() { return "hostElement"; }
}
//# sourceMappingURL=ace-loader.js.map
